import React from 'react';
import { useLogoutWithCacheClear } from '../../hooks/useCacheClear';
import { CacheManager } from '../../utils/cacheManager';

interface LogoutButtonProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Logout button component that ensures complete cache clearing
 * This ensures the app behaves as if the user was never there
 */
export const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  children = 'Logout' 
}) => {
  const logoutWithCacheClear = useLogoutWithCacheClear();

  const handleLogout = () => {
    // Confirm logout
    const confirmed = window.confirm('Are you sure you want to logout? This will clear all your data.');
    
    if (confirmed) {
      // Use comprehensive logout with cache clearing
      logoutWithCacheClear();
    }
  };

  return (
    <button
      onClick={handleLogout}
      className={`px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors ${className}`}
    >
      {children}
    </button>
  );
};

/**
 * Emergency logout function for debugging
 * This completely clears everything and redirects to login
 */
export const emergencyLogout = () => {
  CacheManager.completeLogout('/login');
};
